import React, { useEffect, useState } from 'react';
import Table from './common/Table';
import BaseApiManager from '../networking/baseAPIManager';
import { API_ENDPOINTS } from '../networking/apiConfig';
import moment from 'moment';

const Subscribe = () => {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);

  const columns = [
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Subscribed At",
      accessor: "subscribedAt",
      Cell: ({ value }) => moment(value).format("MMM DD, YYYY - hh:mm A"),
    },
    {
      Header: "Action",
      accessor: "action",
      Cell: ({ row }) => (
        <a
          href={`mailto:${row.original.email}`}
          // target='_blank'
          className="bg-[#454545] text-white text-sm rounded-full px-6 py-2 w-[125px] h-[45px] flex items-center justify-center"
        >
          View
        </a>
      ),
    },
  ];

  useEffect(() => {
    const fetchSubscribers = async () => {
      try {
        const data = await BaseApiManager.get(API_ENDPOINTS.GET_ALL_SUBSCRIBERS);
        setSubscribers(data || []);
      } catch (error) {
        console.error("Failed to fetch subscribers:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSubscribers();
  }, []);

  return (
    <div className="mt-8">
      {loading ? (
        <div className="text-center text-gray-500">Loading...</div>
      ) : (
        <Table columns={columns} data={subscribers} title="All Subscribers" />
      )}
    </div>
  );
};

export default Subscribe;
